<template>
  <BlokkliProvider
    v-bind="blokkliProps"
    isolate
    class="px-section-x pb-[var(--viewport-bottom-space)] tablet:pb-0"
    :edit-path="editPath"
  >
    <footer class="container">
      <div
        v-if="cta?.length || social?.length"
        class="items-center justify-between border-t border-t-border pt-size-5 tablet:flex"
      >
        <!-- CTA. -->
        <BlokkliField
          name="field_paragraphs_cta"
          field-list-type="footerCta"
          :list="filterNullArray(cta)"
          class="grid gap-4 tablet:flex"
        />

        <!-- Social. -->
        <BlokkliField
          name="field_paragraphs_social"
          field-list-type="socialLinks"
          :list="filterNullArray(social)"
          class="social-links mt-6 flex items-center gap-5 tablet:mt-0"
        />
      </div>

      <!-- Main Footer links. -->
      <BlokkliField
        name="field_paragraphs"
        field-list-type="footer"
        :list="filterNullArray(links)"
        class="mt-size-5 flex-wrap justify-between border-t border-t-border tablet:flex tablet:gap-4 tablet:pt-size-5 desktop:flex-nowrap"
      />

      <!-- Awards and Sustainability -->
      <BlokkliField
        name="field_paragraphs_bottom"
        field-list-type="footer"
        :list="filterNullArray(bottom)"
        class="paragraphs-bottom mt-4 grid gap-4 bg-scheme-main-bis p-size-6 tablet:mt-0 tablet:flex tablet:gap-0 tablet:p-size-5"
      />

      <div class="flex justify-between py-4 tablet:py-6">
        <!-- Copyright -->
        <div class="text-size-6">© {{ year }} Zürich Tourismus</div>

        <div v-if="!hasNewNavigation">
          <LanguageSwitcher direction="up" />
        </div>
      </div>
    </footer>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { StorageFooterFragment } from '#graphql-operations'
import { DomainId } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<StorageFooterFragment>()
const { activeDomain } = useSiteContext()

// The path where blökkli editing happens.
// While the footer is visible on every page, editing is only possible
// on the /storage/:id route.
const editPath = computed(() => props.url?.path)

const year = useState('currentYear', () => {
  const date = new Date()
  return date.getFullYear()
})

const hasNewNavigation = computed<boolean>(() => {
  return activeDomain === DomainId.zuerich_com
})
</script>
